import * as types from "./mtypes";
import axios from "axios";
import { handleRequest } from "@/store/utils/requestFunctions";
import * as endpoints from "@/store/constants/endpoints";

export default {
  async signin({ commit }, user) {
    await handleRequest(
      commit,
      () => axios.post(`${endpoints.AUTH_LOGIN}`, user),
      types.REQUEST_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },

  logout({ commit }) {
    commit(types.AUTH_LOGOUT);
  },
};
